import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import './CandidateCard.css';
import CandidateSummary from '../CandidateSummary/CandidateSummary';
import UserAvatar from 'react-user-avatar';
import moreIcon from '../../../assets/images/more-vertical.svg';
import CandidatePhoto from '../../CandidatePhoto/CandidatePhoto';
import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc CandidateCard of single candidate in Talent Pool List section
* @param props
* @return DOMElement
*/
const CandidateCard = (props) => {
  const activeClass = props.activeCandidateId === props.candidate_id ? ' active' : ' inactive';
	const poolStatusSuitableClass = props.poolStatus === 'PROGRESS' ? 'suitable' : '';
  const poolStatusUnSuitableClass = props.poolStatus === 'REGRET' ? 'unsuitable' : '';
  const initialColor=['#E0E9F2', '#C9EDE6', '#C4CAD0', '#F4ADAE', '#E9D7D8', '#EAC0CE'];
  //ConsoleLog("CandidateCard",props.candidate.s3SignedUrl)

  return (
		<Panel className={'pool-card' + activeClass + ' ' + poolStatusSuitableClass + ' ' + poolStatusUnSuitableClass}>
			{(!props.isRecruiter&& props.isNewlyAddedCandidate==true)?
          <div className="card-new-badge">
            <span>New</span>          
          </div>
          : null }
      <Panel.Body>
			{/* Mobile View Section starts */}	
			<MediaQuery query="(max-device-width: 769px)">
        <div className="slick-page-current">
          <strong>{props.count + 1}</strong> of {props.candidateLength}
        </div>
        <CandidateSummary 
          candidate_id={props.candidate_id} 
          candidate={props} 
          print={false} 
          open={true} 
        />
				<div className="open-link">
          <Link 
            className="btn" 
            to={"/candidate/" + props.candidate_id}
          >View Profile</Link>
        </div>
			</MediaQuery>
			{/* Mobile View Section Ends */}	

			{/* Desktop View Section starts */}
			<MediaQuery query="(min-device-width: 768px)">
        
        <div className="candidate-info">
          <CandidatePhoto 
              initials={props.initials} 
              candidatePhoto={props.s3SignedUrl?props.s3SignedUrl:""} 
              user={props.user} 
              attributes={props.attributes} 
              isS3Url={props.isS3Url} 
            />
          <div className="title">
         { props.candidate_fname || props.candidate_lname ? props.candidate_fname+ ' ' +props.candidate_lname:"- Not Specified -"}
          </div>
          <div className="desc-cont">
          {(props.current_job_title /*&& props.current_employer*/) ?
            <div>
              <div className="position">{(props.current_job_title) ? props.current_job_title : '' }</div>
              <div className="desc">{(props.current_employer) ? props.current_employer : '' }</div>
            </div>
          : 
            <div>
              <div className="position">Actively Seeking Employment</div>               
            </div>            
          }
          {props.isRecruiter ?
            <div className="bh-id">
              {(props.candidate_source_id) ? props.candidate_source_id :  '' }
            </div>
          :""}
          </div>
          
          {(props.removeButton) ? 
            <div className="more-container" >
              <span><img src={moreIcon} /></span>
              <div className="more-options">
                <div 
                  className="reschedule-option" 
                  onClick={() => props.handleRescheduleCandidate({ 
                    candidate_id: props.candidate_id,
                    candidate_fname: props.candidate_fname,
                    candidate_lname: props.candidate_lname,
                    candidate_source_id: props.candidate_source_id
                  })}>Reschedule</div>
                <div className="remove-option" onClick={props.deleteConfirm}>Remove</div>
              </div>
            </div> 
          : null}
        </div>
				
				<div className={props.isRecruiter ? "footer recruiter-footer" :"footer"}>
          {(props.isRecruiter && props.editStatus) ? <div className={ "edit-status " + props.editStatus.toLowerCase().replace(" ", "-") }>
            {props.editStatus.toLowerCase()}
          </div> : null }
          <Button 
            value={props.candidate_id} 
            onClick={props.handleCandidateSelect}
            disabled={activeClass=== ' active' ? true : ''}
          >View</Button>
				</div>
			</MediaQuery>
			{/* Desktop View Section ends */}  
			</Panel.Body>
		</Panel>    
  );
}

export default CandidateCard;


// WEBPACK FOOTER //
// ./src/components/Client/CandidateCard/CandidateCard.js